import { AttributeTypeDef } from '../generated/types'
import { RelationshipAttr } from '../attributes'

export function isRelationshipAttr(attr?: AttributeTypeDef): attr is RelationshipAttr {
    return attr?.value.valueType === 'relationship'
}
